import styled from 'styled-components'

import { _S_Normal, _XS_Bold, _XS_Medium, _XS_Normal, mainColors } from '@avantstay/backoffice-core'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px 0;
`

export const Card = styled.div`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 12px;
  background: ${mainColors.white};
`

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 12px;
`

export const Title = styled.span`
  ${_XS_Bold};
  color: ${mainColors.primaryMedium};
`

export const Chip = styled.span`
  ${_XS_Bold};
  color: ${mainColors.accentDark};
  background: ${mainColors.accentExtremelyLight};
  border-radius: 4px;
  padding: 0 4px;
  letter-spacing: 0.05em;
`

export const Channel = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const Spacer = styled.span`
  flex: 1;
`

export const Body = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark2};
  line-height: 1.5;
  margin: 0;
  padding: 0 12px 8px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const Toggle = styled.button`
  ${_XS_Medium};
  border: 0;
  background: none;
  padding: 0;
  margin-left: 4px;
  color: ${mainColors.accentDark};
  cursor: pointer;
`

export const Meta = styled.div`
  ${_XS_Normal};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0 12px 8px;
  color: ${mainColors.neutralExtremelyDark};
`

export const MetaText = styled.span`
  overflow-wrap: anywhere;
`

export const When = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  margin-top: 4px;
`
